import * as EventListener from "../helpers/event-listener";
import csrfToken from "../helpers/csrf-token";

const search = () => {
    let debounceTimer;

    EventListener.input("localitySearch", (input) => {
        clearTimeout(debounceTimer);

        const search = input.value.trim().toLowerCase();

        document.querySelector(".locality-search-result-wrapper").textContent =
            null;

        if (search.length < 2) {
            return;
        }

        debounceTimer = setTimeout(() => {
            oc.ajax("Settings::onAjax", {
                data: {
                    _token: csrfToken,
                    locality_search: search,
                },
                update: {
                    "common/search-results/search-results.htm":
                        ".locality-search-result-wrapper",
                },
            });
        }, 300);
    });
};

search();
